import Password from 'react-better-password';

/**
 * `react-better-password` (0.1.0, без обновлений с 2017) прячет последний введённый символ таймером
 * и не снимает его при размонтировании. Если поле уберут раньше (закрыли модалку меньше чем через
 * секунду после ввода), таймер читает `selectionStart` у уже `null`-ового поля: необработанный
 * `TypeError` в консоли браузера, а в jest — красный соседний тест (IMGM-1584). Предыдущий таймер
 * библиотека сбрасывает сама на каждом вводе, поэтому висит всегда один — его и снимаем.
 */
export class MaskedPassword extends Password {
  componentWillUnmount() {
    clearTimeout((this as unknown as { timer?: ReturnType<typeof setTimeout> }).timer);
  }
}
